module.exports = __webpack_public_path__ + "img/partfour_pic1.e968cf5e.png";